import React, { useContext, useState, useEffect, useRef, useCallback } from 'react';
import { AsDataGrid } from '@adserve/datagrid';
import { AsButton } from '@adserve/adserve-react-components';
import CampaignHistoryGridColumnDefinitions from './CampaignHistoryGridColumnDefinitions';
import { SystemSettingsContext } from '../../../../contexts/SystemSettingsContext';
import moment from 'moment';

// Styles
const gridContainer = {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gridTemplateRows: '1fr',
    gridGap: 0,
    padding: '0px 0px 0px 0px',
    width: '100%',
    height: '150%'
};
const gridItem = {
    textAlign: 'center',
    padding: 0
};
const tableArea = {
    gridColumn: '1 / 4',
    backgroundColor: '#FFFFFF'
};

const CampaignHistoryTablePage = (campaign) => {
    const { dateFormat, timeFormat } = useContext(SystemSettingsContext);
    const [campaignHistory, setCampaignHistory] = useState();
    const gridRef = useRef(null);
    const datetimeFormat = `${dateFormat} ${timeFormat}`;

    // if (campaign?.campaign?.campaignHistory.length) 
    //    console.log('campaign typeof createdDate campaignHistory', typeof campaign?.campaign?.campaignHistory[0].createdDate, campaignHistory)

    // ASSP-8079 Export requires simple changedBy field not createdBy object and
    // formatted changedDate from createdDate datetime - createdDate is string
    //
    useEffect(() => {
      if (campaign?.campaign?.campaignHistory) {
        setCampaignHistory(
            campaign?.campaign?.campaignHistory.map(
                e => {return {
                    ...e,
                    changedBy: e.createdBy?.name,
                    changedDate: moment(e.createdDate)?.format(datetimeFormat)
                }}
            ) 
        );
    } else {
          setCampaignHistory();
      }
    }, [campaign]);

    // ASSP-8079 Export function from "UiRevenueManager\app-src\src\views\RevenueReport\RevenueReport.tsx"
    const onExportToExcel = useCallback(() => {
        if (gridRef.current) {
            const filename = `CampaignHistory_${moment().format('YYYY-MM-DD_HHmm')}.xlsx`;
            gridRef.current.exportToExcel(filename, 'Campaign History');
        }
    }, []);

    return (
        <div>
            <div style={{
                display: 'flex',
                justifyContent: 'right',
                paddingBottom: 16,
                paddingRight: 25,
                marginTop: -39
            }}>
                <AsButton
                    handleClick={onExportToExcel}
                    useSecondaryStyle
                    disabled={!campaignHistory}
                >
                    {window.translate('Download Excel')}
                </AsButton>
            </div>
            <div style={gridContainer}>
                <div style={{ ...gridItem, ...tableArea, position: 'relative', height: (16 * 15)}}>
                    <AsDataGrid
                        data={campaignHistory}
                        columns={CampaignHistoryGridColumnDefinitions(dateFormat, timeFormat)}
                        isLoading={!campaignHistory}
                        ref={gridRef}
                        compact
                    />
                </div>
            </div>
        </div>
    );
};

export default CampaignHistoryTablePage;